PayModalCtrl = ($scope, $modalInstance, PayModalService) ->
  $scope.ok = ->
    PayModalService.navigateToPayment()

  $scope.cancel = ->
    $modalInstance.dismiss('cancel')

PayModalCtrl.$inject = [
  '$scope'
  '$modalInstance'
  'PayModalService'
]

module.exports = PayModalCtrl


// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/components/payment/pay-modal/pay-modal-controller.coffee